import React, { useState, useEffect } from "react";
import { Input } from "antd";
import { FaTrash, FaPlus, FaCheck, FaTimes, FaMinus } from "react-icons/fa";
import TextInputModal from "../../../../TextInputModal";
import { SelectForm } from "../../../../../common/Buttons";
import {
  meanings_options,
  warrantly_option,
} from "../../../../../../helpers/GlobalOptions";

function ContractGoods({
  item,
  index,
  OrderRow,
  onDelete,
  PlanPriceMain,
  updateFieldChanged,
  SelectedItemData,
  setSelectedItemData,
  DisabledInputs,
  addAdditionalItem,
  changeAdditionalItem,
  removeAdditionalItem,
  handeChangePrice,
  setWarranty,
  Warranty,
}) {
  const topercentage = (percent, total) => {
    return ((percent / 100) * total).toFixed(2);
  };
  const frompercentage = (partialValue, totalValue) => {
    return ((100 * partialValue) / totalValue).toFixed(2);
  };
  const getNum = (val) => {
    val = +val || 0;
    return val.toFixed(2);
  };

  useEffect(() => {
    let newArr = [...SelectedItemData];
    if (item.created_at) {
      newArr[index].item_price = getNum(item.item_price);
      newArr[index].item_pricePerc = frompercentage(
        item.item_price,
        item.product_price
      );
    } else {
      newArr[index].item_pricePerc = getNum(PlanPriceMain.percentage);
      newArr[index].item_price = topercentage(
        getNum(PlanPriceMain.percentage),
        item.product_price
      );
    }
    // itemTotal
    const itemPrice = getNum(item.item_price);
    const discount = getNum(item.item_discount);
    const counter = itemPrice - discount;
    newArr[index].item_total = getNum(counter);
    setSelectedItemData(newArr);
  }, [PlanPriceMain]);

  const findItemNames = (item, selector) => {
    const findItem = OrderRow.find((find) => find.value === item.order_row_id);
    if (findItem && selector == "reference") {
      return findItem.product_reference;
    }
    if (findItem && selector == "name") {
      return findItem.label;
    }
    return "";
  };

  return (
    <div className="col-12 mt-1 py-2" style={{ backgroundColor: "#f8f8f8" }}>
      <div>
        <div className="d-flex justify-content-between mb-2">
          <span className="text-bold">
            {item.created_at ? (
              <FaCheck className="mr-2" title={"Created"} color="green" />
            ) : (
              <FaTimes className="mr-2" title={"Creating"} color="red" />
            )}
            ({findItemNames(item, "reference")}) {findItemNames(item, "name")}
          </span>
          {!DisabledInputs && (
            <FaTrash
              style={{ cursor: "pointer", color: "orange" }}
              onClick={onDelete}
            />
          )}
        </div>

        <TextInputModal
          required="true"
          name="product_price"
          type="number"
          text="Price of the item"
          placeholder="Enter"
          value={item.product_price}
          disabled={DisabledInputs}
          onChange={(e) => handeChangePrice(e, index)}
        />
        <TextInputModal
          required="true"
          name="category"
          type="text"
          text="Category"
          placeholder="Enter"
          value={item.category}
          disabled={DisabledInputs}
          onChange={(e) => updateFieldChanged(index, e)}
        />
        <TextInputModal
          required="true"
          type="text"
          name="manufacturer"
          text="Manufacturer"
          placeholder="Enter"
          value={item.manufacturer}
          disabled={DisabledInputs}
          onChange={(e) => updateFieldChanged(index, e)}
        />
        <TextInputModal
          required="true"
          type="text"
          name="model"
          text="Model"
          placeholder="Enter"
          value={item.model}
          disabled={DisabledInputs}
          onChange={(e) => updateFieldChanged(index, e)}
        />
        <TextInputModal
          required="true"
          name="id_number"
          // type="number"
          text="Serial number"
          placeholder="Enter"
          value={item.id_number}
          disabled={DisabledInputs}
          onChange={(e) => updateFieldChanged(index, e)}
        />
        <div className="text-bold my-1">
          Manufacturer's warranty:
          <span className="orange_color">*</span>
        </div>
        <SelectForm
          onlyPlaceholder="Enter"
          options={warrantly_option}
          value={Warranty || undefined}
          disabled={DisabledInputs}
          onChange={(e) => setWarranty(e)}
        />
        <>
          <div className="text-bold my-1 d-flex justify-content-between">
            <div>
              Additional information <span className="orange_color">*</span>
            </div>
            <div>
              <FaPlus
                style={{ color: "green", cursor: "pointer" }}
                onClick={() => addAdditionalItem(index)}
              />
            </div>
          </div>
          {item.additional_data &&
            item.additional_data.map((item, itemIndex) => {
              return (
                <div className="d-flex" key={itemIndex}>
                  <div style={{ width: "45%" }}>
                    <SelectForm
                      onlyPlaceholder="Title"
                      name="key"
                      options={meanings_options}
                      value={item.key}
                      disabled={DisabledInputs}
                      onChange={(e) =>
                        changeAdditionalItem(index, itemIndex, e, "key")
                      }
                    />
                  </div>
                  <div style={{ width: "45%" }}>
                    <Input
                      className="orange"
                      name="text"
                      placeholder="Value"
                      value={item.text}
                      disabled={DisabledInputs || item.key === null}
                      onChange={(e) =>
                        changeAdditionalItem(
                          index,
                          itemIndex,
                          e.target.value,
                          "text"
                        )
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "10%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FaMinus
                      style={{ color: "red", cursor: "pointer" }}
                      onClick={() => removeAdditionalItem(index, itemIndex)}
                    />
                  </div>
                </div>
              );
            })}
        </>
        <label className="text-bold my-1">
          The price of the plan:
          <span className="orange_color">*</span>
        </label>
        <div className="d-flex">
          <div
            className="d-flex align-items-center pr-2"
            style={{ width: "40%" }}
          >
            <div className="position-relative">
              <label className="position-absolute input_text">&#8364;</label>
              <Input
                type="number"
                name="price"
                placeholder="Enter"
                value={item.item_price}
                disabled={DisabledInputs}
                onChange={(e) => handeChangePrice(e, index)}
              />
            </div>
          </div>
          <div
            className="text-bold"
            style={{
              display: "flex",
              alignItems: "center",
              width: "35%",
            }}
          >
            <div className="position-relative">
              <label className="position-absolute input_text">%</label>
              <Input
                type="number"
                name="pricePerc"
                placeholder="Enter"
                value={item.item_pricePerc}
                disabled={DisabledInputs}
                onChange={(e) => handeChangePrice(e, index)}
              />
            </div>
          </div>
          <div
            className="d-flex justify-content-center align-items-center text-secondary"
            style={{ width: "25%" }}
          >
            <span>from the price of the product</span>
          </div>
        </div>
        <label className="text-bold my-1">Discount</label>
        <div className="d-flex">
          <div
            className="d-flex align-items-center pr-2"
            style={{ width: "40%" }}
          >
            <div className="position-relative">
              <label className="position-absolute input_text">&#8364;</label>
              <Input
                type="number"
                name="item_discount"
                placeholder="Enter"
                value={item.item_discount || 0}
                disabled={DisabledInputs}
                onChange={(e) => handeChangePrice(e, index)}
              />
            </div>
          </div>
          <div
            className="text-secondary"
            style={{
              display: "flex",
              alignItems: "center",
              width: "60%",
            }}
          >
            Price after discount, {item.item_total} &#8364;
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContractGoods;
